/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { versaoRequest } from "./versaoRequest";
import { Table } from "antd";
import { DeleteOutlined } from "@ant-design/icons";
import { ModalDelete } from "../../../../Componentes/ModalDelete";
import { ModalStatusDelete } from "../../../../Utils/modalStatus";

export const VersaoCart = ({ id, tab }) => {
  const [versao, setVersao] = useState([]);
  const [openDelete, setOpenDelete] = useState(false);
  const [openStatus, setOpenStatus] = useState(false);
  const [idVersao, setIdVersao] = useState(null);

  useEffect(() => {
    if (tab === 3) {
      getVersaoId();
    }
  }, [tab]);

  const getVersaoId = async () => {
    try {
      const response = await versaoRequest.getVersao({ cartorio_id: id });
      if (response.status === 200 || response.status === 201) {
        const { results } = response.data;
        setVersao(results);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const dataFormatada = (data) => {
    const date = new Date(data);
    const dateFormatted = date.toLocaleString().replace(",", "");
    return dateFormatted;
  };

  const handleDelete = (value) => {
    setOpenDelete(true);
    setIdVersao(value);
  };

  const deleteVersao = async () => {
    try {
      const response = await versaoRequest.deleteVersao(idVersao);

      if (response.status === 204) {
        getVersaoId();
        setOpenDelete(false);
        setOpenStatus(true);
        setIdVersao(null);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const handleCancel = () => {
    setOpenDelete(false);
    setIdVersao(null);
  };

  const columns = [
    {
      title: "Data e hora de versão",
      dataIndex: "data_hora_versao",
      render: (value) => dataFormatada(value),
    },
    { title: "Número versão", dataIndex: "numero_versao" },
    { title: "Sistema", dataIndex: "sistema_descricao" },
    {
      title: "Ações",
      dataIndex: "acoes",
      render: (_, render) => (
        <DeleteOutlined
          style={{ cursor: "pointer" }}
          onClick={() => handleDelete(render.id)}
        />
      ),
    },
  ];

  return (
    <>
      <Table columns={columns} dataSource={versao} />

      <ModalDelete
        message="Deseja realmente deletar esta Versão?"
        visible={openDelete}
        onCancel={handleCancel}
        onConfirm={deleteVersao}
      />

      <ModalStatusDelete
        onCancel={() => setOpenStatus(false)}
        visible={openStatus}
        message="Versão deletada com sucesso!"
      />
    </>
  );
};
